export default __webpack_public_path__ + "static/media/CV_english.1d1579ec.pdf";